import { render, staticRenderFns } from "./zean-kr.vue?vue&type=template&id=195cebb4&scoped=true&"
import script from "./zean-kr.vue?vue&type=script&lang=js&"
export * from "./zean-kr.vue?vue&type=script&lang=js&"
import style0 from "./zean-kr.vue?vue&type=style&index=0&id=195cebb4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195cebb4",
  null
  
)

export default component.exports